import { ILog } from '../../../global/types';
import { ICommand } from 'core-ts-types';
import { Validation } from '../../components/password_validation_popover/password_validation_popover';
import { ErrorsDict, IFormErrorService } from '../../../global/services/form_error_service/form_error_service';
import { IServerResponse } from '../../../global/interfaces/server_response';

export interface ICreateProfileForm {
  email: string;
  first_name: string;
  last_name: string;
  password: string;
  google_captcha_response: string;
}

export interface ICreateProfileScope extends ng.IScope {
  create_profile: ng.IFormController;
}

export class CreateProfileController {
  public profile: ICreateProfileForm;
  public validations: {
    email: RegExp;
  };
  public passwordValidations: Validation;
  public isPasswordValid = false;
  private errors: ErrorsDict;

  constructor(
    private $state: ng.ui.IStateService,
    private $timeout: ng.ITimeoutService,
    private $scope: ICreateProfileScope,
    private createAccountCommand: ICommand,
    private resetLocalAccountCommand: ICommand,
    private validatePasswordCommand: ICommand,
    private loginCommand: ICommand,
    private loadTransferStudentCommand: ICommand,
    private phxPasswordValidationPopoverDelegate: any,
    private emailRegex: RegExp,
    private log: ILog,
    private captchaWidgetDelegate: any,
    private formErrorService: IFormErrorService
  ) {
    this._initialize();
  }

  private _initialize(): void {
    this.profile = {
      email: '',
      first_name: '',
      last_name: '',
      password: '',
      google_captcha_response: ''
    };
    this.validations = {
      email: this.emailRegex
    };
    this.onPasswordChange();
  }

  // TODO move to service? what is best way to make this DRY?
  onPasswordChange(): void {
    this.$timeout(() => {
      this.isPasswordValid = false;
      this.validatePasswordCommand(this.profile.password || '').then((res) => {
        this.passwordValidations = res;
        this.isPasswordValid = _.all(this.passwordValidations);
      });
    });
  }

  submitForm(): void {
    this.errors = {};
    this.createAccountCommand(this.profile)
      .then(() => {
        return this.loginCommand({
          username: this.profile.email,
          password: this.profile.password
        });
      })
      .then(() => {
        // FIXME this extra call could be avoided if we didn't clean up
        // student data everytime loginCommand is called
        return this.loadTransferStudentCommand();
      })
      .then(() => {
        this.log.user.success({
          content: 'Welcome! Your profile has been created.',
          dismissOnTimeout: true,
          dismissButton: true
        });
        return this.$state.go('my.profile.additional_information', { source: 'account-creation' });
      })
      .catch((res: any): any => {
        this.captchaWidgetDelegate.reset();
        this.errors = this.formErrorService(res.data!.error);
        return Promise.reject(res);
      });
  }
}

angular.module('capability-ng-user-app').controller('ngCreateProfileController', CreateProfileController);



// WEBPACK FOOTER //
// ./app/lib/user_app/views/create_profile/create_profile.ts